import React from "react";

const paths = {
  cloud: (
    <path d="M7 18.5a4.5 4.5 0 0 1-.42-8.98 6 6 0 0 1 11.7 1.35A3.75 3.75 0 0 1 17.5 18.5H7Z" />
  ),
  chip: (
    <>
      <rect x="6.5" y="6.5" width="11" height="11" rx="2" />
      <rect x="10" y="10" width="4" height="4" rx="0.5" />
      <path d="M9 3.5v3M15 3.5v3M9 17.5v3M15 17.5v3M3.5 9h3M3.5 15h3M17.5 9h3M17.5 15h3" />
    </>
  ),
  zap: <path d="M13.2 2.5 5 13.5h5.4L10.8 21.5 19 10.5h-5.4l-.4-8Z" />,
  shield: (
    <>
      <path d="M12 3 5 5.8v5.4c0 4.3 3 7.9 7 9.3 4-1.4 7-5 7-9.3V5.8L12 3Z" />
      <path d="m9.2 11.8 2 2 3.6-4" />
    </>
  ),
  loop: (
    <>
      <path d="M8.5 7.5h7a4.5 4.5 0 0 1 0 9h-7a4.5 4.5 0 0 1 0-9Z" />
      <path d="m13.5 5.5 2 2-2 2M10.5 14.5l-2 2 2 2" />
    </>
  ),
  chart: (
    <>
      <path d="M4 4v15.5h16" />
      <path d="m6.5 8 4 4.5 3-2.5 4.5 5" />
      <path d="M18 11.5V15h-3.5" />
    </>
  ),
  bolt: <path d="M13.2 2.5 5 13.5h5.4L10.8 21.5 19 10.5h-5.4l-.4-8Z" />,
  badgeDollar: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M14.6 9.3c-.4-.9-1.4-1.4-2.6-1.4-1.5 0-2.6.8-2.6 2 0 2.7 5.4 1.3 5.4 4 0 1.2-1.2 2.1-2.8 2.1-1.3 0-2.4-.6-2.8-1.6M12 6.2v1.7m0 8.1v1.7" />
    </>
  ),
  book: (
    <>
      <path d="M4.5 5.5A2.5 2.5 0 0 1 7 3h12.5v15H7a2.5 2.5 0 0 0-2.5 2.5v-15Z" />
      <path d="M4.5 20.5A2.5 2.5 0 0 1 7 18h12.5M8.5 7.5h7" />
    </>
  ),
  rocket: (
    <>
      <path d="M9.5 14.5c-3-1-4.5-5.5-3-9 3.5-1.5 8 0 9 3M9.5 14.5l-3.4 1.2L7.3 12M9.5 14.5 14 10" />
      <path d="M14.5 9.5c2.5-2.5 5.5-3 6.5-2.5.5 1-.5 4-2.5 6.5-2.3 2.7-6 4.5-8 5l-2-2c.5-2 2.3-4.7 6-7Z" />
      <path d="M6 18.5c-1 .5-1.8 2.3-1.5 3 .7.3 2.5-.5 3-1.5" />
    </>
  ),
  layers: (
    <>
      <path d="m12 3.5 8.5 4.5L12 12.5 3.5 8 12 3.5Z" />
      <path d="m3.5 12.5 8.5 4.5 8.5-4.5M3.5 17l8.5 4.5L20.5 17" />
    </>
  ),
  users: (
    <>
      <circle cx="9" cy="8.5" r="3.25" />
      <path d="M3.5 19.5c.5-3.3 2.7-5 5.5-5s5 1.7 5.5 5" />
      <path d="M15.5 5.6a3.25 3.25 0 0 1 0 5.9M17.5 14.9c1.7.7 2.7 2.2 3 4.6" />
    </>
  ),
  trendUp: (
    <>
      <path d="m3.5 17.5 5.5-6 3.5 3 7-8" />
      <path d="M15 6.5h4.5V11" />
    </>
  ),
  calendar: (
    <>
      <rect x="3.5" y="5" width="17" height="15.5" rx="2" />
      <path d="M8 2.75V7M16 2.75V7M3.5 10h17" />
    </>
  ),
  arrowUpRight: <path d="M7 17 17 7M9 7h8v8" />,
  arrowRight: <path d="M4.5 12h15m-6-6 6 6-6 6" />,
  check: <path d="m4.5 12.5 5 5 10-11" />,
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3.5 7 8.5 6 8.5-6" />
    </>
  ),
  phone: (
    <path d="M7.6 3.5H5A1.5 1.5 0 0 0 3.5 5.2 16.5 16.5 0 0 0 18.8 20.5a1.5 1.5 0 0 0 1.7-1.5v-2.6a1.5 1.5 0 0 0-1.2-1.5l-2.8-.6a1.5 1.5 0 0 0-1.5.6l-.8 1a12.4 12.4 0 0 1-5.1-5.1l1-.8a1.5 1.5 0 0 0 .6-1.5l-.6-2.8a1.5 1.5 0 0 0-1.5-1.2Z" />
  ),
  pin: (
    <>
      <path d="M12 21.5s-7-6.4-7-11.5a7 7 0 0 1 14 0c0 5.1-7 11.5-7 11.5Z" />
      <circle cx="12" cy="9.75" r="2.5" />
    </>
  ),
  linkedin: (
    <>
      <rect x="3.5" y="3.5" width="17" height="17" rx="2.5" />
      <path d="M8 10.5V17M8 7.5v.1M12 17v-3.8c0-1.4.9-2.4 2.2-2.4 1.3 0 2.1 1 2.1 2.4V17" />
    </>
  ),
  github: (
    <path d="M12 3a9.2 9.2 0 0 0-2.9 17.9c.5.1.6-.2.6-.4v-1.6c-2.6.6-3.1-1.1-3.1-1.1-.4-1-1-1.3-1-1.3-.9-.6 0-.6 0-.6.9.1 1.4 1 1.4 1 .8 1.4 2.2 1 2.7.8.1-.6.3-1 .6-1.3-2-.2-4.2-1-4.2-4.6 0-1 .4-1.8 1-2.5-.1-.2-.4-1.2.1-2.4 0 0 .8-.3 2.5 1a8.6 8.6 0 0 1 4.6 0c1.7-1.3 2.5-1 2.5-1 .5 1.2.2 2.2.1 2.4.6.7 1 1.5 1 2.5 0 3.6-2.2 4.4-4.2 4.6.3.3.6.8.6 1.7v2.4c0 .2.1.5.6.4A9.2 9.2 0 0 0 12 3Z" />
  ),
  youtube: (
    <>
      <rect x="2.75" y="5.5" width="18.5" height="13" rx="3.5" />
      <path d="m10 9.25 5 2.75-5 2.75v-5.5Z" />
    </>
  ),
  twitter: (
    <path d="M4 4.5 10.4 13 4.4 19.5h2.2l4.8-5.3 4 5.3H20L13.3 10.6l5.6-6.1h-2.2l-4.4 4.9-3.7-4.9H4Z" />
  ),
  external: <path d="M9 5h10v10M19 5 5 19" />,
  plus: <path d="M12 5v14M5 12h14" />,
};

const Icon = ({ name, size = 24, strokeWidth = 1.7, className }) => {
  const content = paths[name];
  if (!content) return null;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {content}
    </svg>
  );
};

export default Icon;
